import { Injectable } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';
import { ICaptchaRefresh } from '../../models/results/result';
import { DataProvider } from '../../providers/basic/data.service';

@Injectable({
  providedIn: 'root'
})
export class CaptchaService extends DataProvider<any> {
  /**
   * Loads the captcha task of the visitor's own backend session (CS4-2790).
   *
   * Only call this in the browser: during prerendering every request runs in one shared session,
   * whose task the transfer cache would hand to the browser — the very task the backend rejects.
   * The request therefore also bypasses the transfer cache.
   * @param componentName The name of the captcha field.
   * @returns The task, or undefined when it could not be loaded.
   */
  current(componentName: string): Observable<ICaptchaRefresh | undefined> {
    return this.http
      .get<ICaptchaRefresh>(`${this.url}f/captcha`, {
        headers: this.generateHeaders(),
        params: { componentName },
        transferCache: false
      })
      .pipe(
        map((data) => DataProvider.mapCasesReverse(data) as ICaptchaRefresh),
        catchError(() => of(undefined))
      );
  }
}
